// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfirmChangeRadabankPasswordNative_wrapper__Dz7p9","button":"ConfirmChangeRadabankPasswordNative_button__ZXFQe"};